import React from 'react';
import '/Users/jilin/projects/antd/rc-dialog/docs/demo/pure.md?watch=parent';
import * as docs_demo_pure_demo_pure_deps_1 from 'react';
import * as docs_demo_pure_demo_pure_deps_2 from '@rc-component/dialog';
import * as docs_demo_pure_demo_pure_deps_3 from '@rc-component/select/assets/index.less';
import * as docs_demo_pure_demo_pure_deps_4 from '/Users/jilin/projects/antd/rc-dialog/assets/index.less';
export const demos = {
  'docs-demo-pure-demo-pure': {
    component: React.memo(React.lazy(() => import( /* webpackChunkName: "demos" */ '/Users/jilin/projects/antd/rc-dialog/docs/examples/pure.tsx?techStack=react'))),
    asset: {
  "type": "BLOCK",
  "id": "docs-demo-pure-demo-pure",
  "refAtomIds": [],
  "dependencies": {
    "index.tsx": {
      "type": "FILE",
      "value": require('/Users/jilin/projects/antd/rc-dialog/docs/examples/pure.tsx?dumi-raw').default
    },
    "react": {
      "type": "NPM",
      "value": "18.3.1"
    },
    "@rc-component/dialog": {
      "type": "NPM",
      "value": "1.5.1"
    },
    "@rc-component/select": {
      "type": "NPM",
      "value": "1.1.3"
    },
    "../../assets/index.less": {
      "type": "FILE",
      "value": require('/Users/jilin/projects/antd/rc-dialog/assets/index.less?dumi-raw').default
    }
  },
  "entry": "index.tsx"
},
    context: {
  "../../assets/index.less": docs_demo_pure_demo_pure_deps_4,
  "react": docs_demo_pure_demo_pure_deps_1,
  "@rc-component/dialog": docs_demo_pure_demo_pure_deps_2,
  "@rc-component/select/assets/index.less": docs_demo_pure_demo_pure_deps_3,
  "/Users/jilin/projects/antd/rc-dialog/assets/index.less": docs_demo_pure_demo_pure_deps_4
},
    renderOpts: {
          
          compile: async (...args) => {
            return (await import('/Users/jilin/projects/antd/rc-dialog/node_modules/dumi/dist/client/misc/reactDemoCompiler.js')).default(...args);
          },
        },
  },
};